export default "/images/factory.svg?ffbc181ede7299661017b7ce17bf5e32";